/*
 * @providesModule SkillzSDK
 *
 */

import {NativeModules} from 'react-native';
import SkillzRouter from 'SkillzRouter';

const gameId = NativeModules.SkillzModule.App.GameId as string;

const SkillzSDK = {
  popNavigatorToRoot: () => {
    // @ts-ignore
    SkillzRouter.replace(`/games/${gameId}/home`);
  },
  resetToHomeScreen: () => {
    // @ts-ignore
    SkillzRouter.replace(`/games/${gameId}/home`);
  },
  isShowingFraudPrompt: () => false,
  isSDKReadyToDisplay: () => true,
  closeSideMenu: () => {},
  enableSideMenu: () => {},
  disableSideMenu: () => {},
  getNavigator: () => {
    console.log('WebSDK: SkillzSDK.getNavigator() MOCK USED');
    return {}
  },
  getRouteLength: () => 0,
};

export default SkillzSDK;
